import { Button, ButtonProps, ThemeOptions } from '@mui/material'

export { Button }

export type { ButtonProps }

export const buttonThemeOverrides: ThemeOptions['components'] = {
  MuiButton: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 1.5,
        textTransform: 'none',
        ...(ownerState.variant === 'contained'
          ? { WebkitFontSmoothing: 'antialiased' }
          : {}),
      }),
    },
  },
}
